import React, { useCallback } from "react";
import _ from 'lodash';
import clsx from 'clsx';
import { useTranslation } from "react-i18next";
import { withRouter, useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';

import useAsideState from "../../../hooks/useAsideState";
import MenuButton from "../../navigate/MenuButton";
import HomeButton from "../../navigate/HomeButton";
import { TYPE, URL } from "../../../constant";
import { useUserInfo } from "../../../hooks";
import useAmplitude from "../../../hooks/useAmplitude";

const Header = withRouter(() => {
  const { t } = useTranslation();
  const history = useHistory();
  const { setAsideState } = useAsideState();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const deviceType = useSelector(state => state.deviceInfo.type);

  const setTab = () => {
    setAsideState({tab : 'topic'});
  };

  React.useEffect(setTab, []);

  const handlePage = useCallback((path) => {
    history.push(path);
  }, [history]);

  const handleMenuClick = useCallback(() => {
    setAsideState({ menu: true });
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '메인메뉴 조회'});
  }, [])
  
  const handleBackClick = () => {
    console.log("***** 주제학습 페이지 -> 메인 페이지")
    handlePage(URL.SELECT_LEARNING)
  }

  const handleLearningNote = () => {
    console.log(`***** 주제학습 페이지 -> 학습노트 페이지`)
    history.push(URL.COURSE_LEARNING.LEARNING_NOTE);
  };

  return (
    <div className="btns_wrap header-trans cls">
      <div className={clsx(
        "center_wrap cls",
        info.channelCode === TYPE.CHANNEL.GM && 'pc_w1400'
      )}>
        <div className="tit_area">
          {
            !_.isEqual(deviceType, TYPE.DEVICE.PHONE) && <HomeButton/>
          }
          <button
            className="btn_exit3 hide_pc hide_t"
            onClick={handleBackClick}
            type="button"
          >
            <img src={`${process.env.PUBLIC_URL }/static/images/icon/ic_ar_left.svg`} alt="" />
          </button>
          <button
            type="button"
            className="tit_btn"
            onClick={handleBackClick}
          >{t("LC_04_01.msg001")}</button>
        </div>
        <div className="right_area">
          <div className="menu_btn">
            { info.channelCode === TYPE.CHANNEL.WJTB && (
                <MenuButton
                  iconPath="/static/images/icon/ic_mn_w@2x.png"
                />
              )
            }
            {
              info.channelCode === TYPE.CHANNEL.GM && (
                <>
                  <button
                    type="button"
                    className="head_btn purple"
                    onClick={handleLearningNote}
                  >
                    <img
                      alt=""
                      src={`${process.env.PUBLIC_URL}/static/images/icon/ic_gm_note_2@2x.png`}
                    />
                  </button>
                  <button
                    className="head_btn"
                    type="button"
                    onClick={() => setAsideState({ menu: true })}
                  >
                    <img
                      alt=""
                      src={`${process.env.PUBLIC_URL}/static/images/icon/ic_mn_w@2x.png`}
                    />
                  </button>
                </>
              )
            }
            {
              info.channelCode === TYPE.CHANNEL.GLOBAL01 
                && (
                  <>
                    {/* 로그인 버튼 */}
                    { info.memberType === TYPE.GB_USER_TYPE.GUEST &&
                      <button type="button" onClick={() => handlePage(URL.ACCOUNT.LOGIN)}>
                        <img src="./static/images/payment/ic_pay_login.svg" alt="login"/>
                      </button>
                    }   
                    <button
                      type="button"
                      onClick={handleMenuClick}
                    >
                      <img
                        alt=""
                        src={`${process.env.PUBLIC_URL}/static/images/icon/btn_menu_th.svg`}
                      />
                    </button>
                  </>
                )
              }
          </div>
        </div>
      </div>
    </div>
  );
});

export default Header;

